// Editable fields for PA-2b draft action cards.

import type { Dispatch, SetStateAction } from "react";

type DraftFieldsProps = {
  toolId: "service_request_draft" | "lead_draft";
  args: Record<string, unknown>;
  setArgs: Dispatch<SetStateAction<Record<string, unknown>>>;
  disabled: boolean;
};

export function PaActionCardDraftFields({ toolId, args, setArgs, disabled }: DraftFieldsProps) {
  if (toolId === "service_request_draft") {
    return (
      <div className="space-y-1">
        <label className="block text-[10px] text-amber-900 dark:text-amber-200">
          Description
          <textarea
            value={String(args.description ?? "")}
            onChange={(e) => setArgs((prev) => ({ ...prev, description: e.target.value }))}
            disabled={disabled}
            rows={2}
            className="mt-0.5 w-full rounded border border-amber-200 bg-white px-1.5 py-1 text-xs dark:border-amber-800 dark:bg-zinc-900"
          />
        </label>
        <label className="block text-[10px] text-amber-900 dark:text-amber-200">
          Location label
          <input
            value={String(args.location_label ?? "")}
            onChange={(e) => setArgs((prev) => ({ ...prev, location_label: e.target.value }))}
            disabled={disabled}
            className="mt-0.5 w-full rounded border border-amber-200 bg-white px-1.5 py-1 text-xs dark:border-amber-800 dark:bg-zinc-900"
          />
        </label>
        <label className="block text-[10px] text-amber-900 dark:text-amber-200">
          Preferred timeframe
          <input
            value={String(args.preferred_timeframe ?? "")}
            onChange={(e) => setArgs((prev) => ({ ...prev, preferred_timeframe: e.target.value }))}
            disabled={disabled}
            className="mt-0.5 w-full rounded border border-amber-200 bg-white px-1.5 py-1 text-xs dark:border-amber-800 dark:bg-zinc-900"
          />
        </label>
      </div>
    );
  }

  return (
    <div className="space-y-1">
      <label className="block text-[10px] text-amber-900 dark:text-amber-200">
        Customer name
        <input
          value={String(args.customer_name ?? "")}
          onChange={(e) => setArgs((prev) => ({ ...prev, customer_name: e.target.value }))}
          disabled={disabled}
          className="mt-0.5 w-full rounded border border-amber-200 bg-white px-1.5 py-1 text-xs dark:border-amber-800 dark:bg-zinc-900"
        />
      </label>
      <label className="block text-[10px] text-amber-900 dark:text-amber-200">
        Phone
        <input
          value={String(args.phone ?? "")}
          onChange={(e) => setArgs((prev) => ({ ...prev, phone: e.target.value }))}
          disabled={disabled}
          className="mt-0.5 w-full rounded border border-amber-200 bg-white px-1.5 py-1 text-xs dark:border-amber-800 dark:bg-zinc-900"
        />
      </label>
      <label className="block text-[10px] text-amber-900 dark:text-amber-200">
        Product / size
        <input
          value={[args.product_line, args.size_config].filter(Boolean).join(" · ")}
          onChange={(e) => {
            const raw = e.target.value;
            const [product_line, ...rest] = raw.split("·").map((s) => s.trim());
            setArgs((prev) => ({
              ...prev,
              product_line: product_line || undefined,
              size_config: rest.join(" · ") || undefined,
            }));
          }}
          disabled={disabled}
          placeholder="e.g. metal building · 12x20"
          className="mt-0.5 w-full rounded border border-amber-200 bg-white px-1.5 py-1 text-xs dark:border-amber-800 dark:bg-zinc-900"
        />
      </label>
      <label className="block text-[10px] text-amber-900 dark:text-amber-200">
        Previous customer search
        <input
          value={String(args.contact_query ?? "")}
          onChange={(e) => setArgs((prev) => ({ ...prev, contact_query: e.target.value }))}
          disabled={disabled}
          className="mt-0.5 w-full rounded border border-amber-200 bg-white px-1.5 py-1 text-xs dark:border-amber-800 dark:bg-zinc-900"
        />
      </label>
    </div>
  );
}
